import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import { connect } from "react-redux"
import { getPrizes, addRedemption, getRedemptionsActivity } from "../../store/plantstore/actions"

import DataTable from 'react-data-table-component';
import { nanoid } from 'nanoid'
import {
  Container,
  Row,
  Col,
  Badge,
  Button,
  Card,
  CardBody,
  CardTitle,
  CardHeader,
  CardText,
  CardSubtitle,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Media,
  Nav,
  NavItem,
  NavLink,
  Table,
  TabContent,
  TabPane
} from "reactstrap"
import classnames from "classnames"
import { Link } from "react-router-dom"
import { Image } from '@aws-amplify/ui-react';
import Storage from '@aws-amplify/storage'

import BootstrapTheme from "@fullcalendar/bootstrap"

//i18n
import { withTranslation } from "react-i18next"

const PlantStore = props => {
 const { prizes, redemptions, activity, coins, onAddRedemption, onGetRedemptionsActivity, onGetPrizes } = props
 const [modal_redeem, setmodal_redeem] = useState(false)
 const [redeemSubmit, setRedeemSubmit] = useState(false)
 const [currItem, setCurrItem] = useState({})
 const [itemOption, setItemOptionValue] = useState()
 const [activeTab, setactiveTab] = useState("1")
 const username = JSON.parse(localStorage.getItem("user")).user;

 useEffect(() => {
    onGetPrizes()
    console.log("SDFADF");
    onGetRedemptionsActivity(username)
  }, [])

  function setItemOption(type) {
    setItemOptionValue(type)
  }

  function toggle(tab) {
    if (activeTab !== tab) {
      setactiveTab(tab)
    }
  }

  function tog_redeem() {
    setmodal_redeem(!modal_redeem)
    removeBodyCss()
  }

  function show_redeem_dialog(item) {
    for (var i=0; i<prizes.length; i++) {
	var prize = prizes[i];
        if (prize.store_item_id==item) {
	    setCurrItem(prizes[i]);
	    break;
	}
    }
    tog_redeem();
  }

  function redeem_plant() {
     // add item to user
     var redemption = {
	 item: currItem.name,
	 option: itemOption,
	 date: new Date().toISOString().split('T')[0],
	 coins: currItem.coins,
	 username: username, 
	 redemption_id: nanoid(11),
	 status: "Submitted"
    }
    onAddRedemption(redemption)
    tog_redeem();
    setRedeemSubmit(true);
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }

  const redemption_columns = [
                {
                        selector: row => row.redemption_id,
			name: "ID",
                },
                {
                        selector: row => row.item,
			name: "Plant/Item"
                },

                {
                        selector: row => row.option,
                        name: "Variety/Type"
                },

                {
                        selector: row => row.date,
                        name: "Redemption Date",
                },
                {
                        selector: row => row.coins,
                        name: "Coins"
                },
	        {
                        selector: row => row.status,
                        name: "Status"
                }
	 ];

 const activity_columns = [
                {
                        selector: row => row.description,
                        name: "Event"
                },
                {
                        selector: row => row.target,
                        name: "Detail"
                },
	 
                {
                        selector: row => row.date,
                        name: "Date"
                },
                {
                        selector: row => row.coins,
                        name: "Coins"
                },
         ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}

          <Row>
            <Col xl="12">
             <Card outline className="border">
                <CardHeader  style={{backgroundColor:'#AEBFFF'}}>
                  <h5>
                    GIY Plant Prizes 
                  </h5>
                </CardHeader>
                <CardBody>
	   <h5 className="text-warning">Current Balance: {coins} coins</h5>

	  <Nav tabs>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "1",
                        })}
                        onClick={() => {
                          toggle("1")
                        }}
                      >
                        Prizes 
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "2",
                        })}
                        onClick={() => {
                          toggle("2")
                        }}
                      >
                        Redemptions
                      </NavLink>
                    </NavItem>
 <NavItem>
                      <NavLink
                        style={{ cursor: "pointer" }}
                        className={classnames({
                          active: activeTab === "3",
                        })}
                        onClick={() => {
                          toggle("3")
                        }}
                      >
                        Activity
                      </NavLink>
                    </NavItem>
                  </Nav>

	          <TabContent activeTab={activeTab}>
                    <TabPane tabId="1" className="p-3">
	  <Row>
	   {prizes.map((prize, key) => (
	       <Col md="3">
                  <Card outline color="info" className="border" key={"card_"+key}>
                     <CardBody>
                        <div className="product-img position-relative">
                           <center> <center><Image style={{"width": "150px"}} onClick={() => show_redeem_dialog(prize.store_item_id)} src={prize.s3_image} /></center>
</center>
                          </div>
                          <div className="mt-4 text-center">
                            <h6 className="mb-3">
		                {prize.name}
                            </h6>
                            <h6 className="my-0">
                              <b>{prize.coins} Coins</b>
                            </h6>
                            <span className="text-muted me-2">
                                Ships {prize.shipping_date}
                              </span>
                          </div>
                        </CardBody>
                      </Card>
             </Col>
            ))}
	  </Row>

	            </TabPane>
	  <TabPane tabId="2" className="p-3">
                           <Card>
             <DataTable
                        data={redemptions}
                        columns={redemption_columns}
                                                                        />
          </Card>
                    </TabPane>
                  <TabPane tabId="3" className="p-3">
                           <Card>
          <DataTable
                        data={activity}
                        columns={activity_columns}
                                                                        />
          </Card>
                    </TabPane>


                   </TabContent>
                </CardBody>
              </Card>
	    </Col>
	  </Row>

          {redeemSubmit ? (
                    <SweetAlert
                      onConfirm={() => {
                        setRedeemSubmit(false)
                      }}
		      timeout={2000}
                    >
		      <span style={{fontSize:'1em'}}>Your redemption has been submitted.  We'll process it as soon as possible</span>
		    </SweetAlert>
                  ) : null}



	  <Modal
               isOpen={modal_redeem}
               toggle={() => {
                          tog_redeem()
                        }}
                      >
                        <div className="modal-header">
	                   <h5 className="modal-title mt-0" id="myModalLabel">
                             {currItem.name} 
	                  </h5>
	                 
                          <button
                            type="button"
                            onClick={() => {
                              setmodal_redeem(false)
                            }}
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body">
                          <Row>
	                    <Col md={4}>
	                        <Image style={{"width": "150px"}} src={currItem.s3_image} />
	                    </Col>
	                    <Col md={8}>
	                          <span className="text-warning">{currItem.coins} coins</span>
                                  <br/>
	                         <Badge color="primary" className="mr-1">
                                     {currItem.shipping_date}
	                         </Badge>
	                          <br/>
	                        {currItem.description}
	                        {currItem.Type && 
				   <p>
				     <br/>
				     <h6>Choose which item you'd like</h6>
				     <Input type="select" onChange={e => setItemOption(e.target.value)}>
					{currItem.Type.map((option, key) => (
						<option value={option}>{option}</option>
					))}
				   </Input>
				   </p>
				}
	                        {currItem.store_item_id=="seed_packet" &&
				     <p>
				       <br/>
				       <h6>Enter in the Variety and Species of Seed that you'd like.  We'll try our best to match up your desired seed packet with what is in our inventory.</h6>
				       <Input type="text" onChange={e => setItemOption(e.target.value)}/>
			            </p>
				}
	                     </Col>
	                  </Row>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={() => {
                              tog_redeem()
                            }}
                            className="btn btn-secondary waves-effect"
                            data-dismiss="modal"
                          >
                            Close
                          </button>
                          <button
                            type="button"
	                    onClick={() => {
                               redeem_plant()
                            }}

                            className="btn btn-primary waves-effect waves-light"
                          >
                             Redeem 
                          </button>
                        </div>
                      </Modal>



        </Container>
      </div>
    </React.Fragment>
  )
}

PlantStore.propTypes = {
  t: PropTypes.any
}

const mapStateToProps = ({ plantstore }) => {
  return ({
       redemptions: plantstore.redemptions,
       coins: plantstore.coins,
       activity: plantstore.activity,
       prizes: plantstore.prizes})
}

const mapDispatchToProps = dispatch => ({
  onGetPrizes: () => dispatch(getPrizes()),
  onGetRedemptionsActivity: (username) => dispatch(getRedemptionsActivity(username)),
  onAddRedemption: (redemption) => dispatch(addRedemption(redemption))
})

export default connect(mapStateToProps, mapDispatchToProps)(PlantStore)
